import React from 'react';
import { get } from 'lodash';
import validator from 'validator';
import { JoinerEditorTabs, JoinerEditorHeader, JoinerEditorButtons } from '../joinerEditor';
import Edit from '../editForms/edit/DialSmithStimEdit';
import Options from '../editForms/options/DialSmithStimOptions';
import Timing from '../editForms/timing/Timing';
import Rules from '../editForms/rules/Rules';

import './DialSmithStimEditor.css';

class DialSmithStimEditor extends React.Component {
  saveEnabled = () => {
    const accessUrl = get(this.props.joiner, 'stim.media.accessUrl') || '';
    return validator.isURL(accessUrl) && this.props.saveEnabled;
  };

  render() {
    const { props } = this;
    return (
      <>
        <JoinerEditorTabs tabs={props.tabs} joinerInfo={props.joinerInfo} hideMedia />
        <div className="joiner-editor">
          <JoinerEditorHeader {...props} />
          <div className="joiner-editor-form">
            <Edit {...props} />
            <Options {...props} />
            <Timing {...props} />
            <Rules {...props} />
          </div>
          <JoinerEditorButtons
            toggle={props.toggle}
            saveEnabled={this.saveEnabled()}
            saveJoiner={props.saveJoiner}
            readOnly={props.readOnly}
          />
        </div>
      </>
    );
  }
}

export default DialSmithStimEditor;
